export default "__VITE_ASSET__Dg6cW8DQ__"